<div class="row">
	<div class="col-12 text-center py-2" *ngIf="loading && !cards.length">
		<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
	</div>

	<div *ngFor="let card of cards" [ngClass]="card.wide ? 'col-md-12' : 'col-md-6'">
		<div class="dcl-wrap" [ngStyle]="dclTheme(card.accent)">
			<div class="dcl-icon-badge">
				<i class="material-icons">{{ card.icon }}</i>
			</div>
			<div class="dcl-header">
				<div class="dcl-title-group">
					<span class="dcl-title">{{ card.title }}</span>
					<span class="dcl-subtitle" *ngIf="card.total > 0">{{ useQty ? ((card.total | number:'1.0-0') + ' units') : (card.total | currency) }} total</span>
				</div>
			</div>
			<div class="dcl-body">
				<div class="dcl-bar-row" *ngFor="let row of card.rows; let i = index" [class.dcl-bar-row--top]="i === 0 && card.key !== 'low'">
					<span class="dcl-rank"
						[class.dcl-rank--gold]="i === 0 && card.key !== 'low'"
						[class.dcl-rank--silver]="i === 1 && card.key !== 'low'"
						[class.dcl-rank--bronze]="i === 2 && card.key !== 'low'">{{ i + 1 }}</span>
					<div class="dcl-bar-main">
						<div class="dcl-bar-head">
							<span class="dcl-bar-label" [title]="row.label">{{ row.label }}</span>
							<span class="dcl-bar-value">{{ useQty ? (row.value | number:'1.0-0') : (row.value | currency) }}</span>
						</div>
						<div class="dcl-bar-track">
							<div class="dcl-bar-fill" [style.width.%]="row.pct"></div>
						</div>
					</div>
				</div>
				<p class="text-muted m-0" *ngIf="!card.rows.length && !loading">No sales in this window.</p>
			</div>
		</div>
	</div>
</div>
